module.exports = __webpack_public_path__ + "static/pid-ug-11-en-linkbutton-2eb994323567ef87f48128d10d09fd98.png";